import { Quote, UserInfo } from 'shared/types';
import { formatDate } from 'shared/utility';

export function buildCsvExport(quote: Quote | undefined, { firstName, lastName, email }: UserInfo) {
  if (quote === undefined) {
    return {
      csvData: [],
      csvHeaders: [],
    };
  }
  const { products, customer, expirationDate, quoteNumber } = quote;
  const csvData = products.map(product => {
    return {
      quoteNumber,
      customerNumber: customer.customerNumber,
      firstName,
      lastName,
      email,
      vendorId: product.vendorId,
      productNumber: product.itemId,
      productDescription: product.name,
      unitPrice: product.revisedPrice,
      quantity: product.quantity,
      extendedPrice: product.revisedPrice && product.revisedPrice * Number(product.quantity),
      inventoryKicker: product.inventoryKicker,
      totalPrice: product.extendedPrice,
      unitCost: product.lastCostPaid,
      extendedCost: Number(product.lastCostPaid) * Number(product.quantity),
      expirationDate: formatDate(new Date(expirationDate)),
    };
  });

  const csvHeaders = [
    { label: 'Quote Number', key: 'quoteNumber' },
    { label: 'Sales Rep First Name', key: 'firstName' },
    { label: 'Sales Rep Last Name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'Customer #', key: 'customerNumber' },
    { label: 'Vendor #', key: 'vendorId' },
    { label: 'Product #', key: 'productNumber' },
    { label: 'Product Description', key: 'productDescription' },
    { label: 'Unit Price', key: 'unitPrice' },
    { label: 'Quantity', key: 'quantity' },
    { label: 'Extended Price', key: 'extendedPrice' },
    { label: 'Inventory Kicker', key: 'inventoryKicker' },
    { label: 'Total Price', key: 'totalPrice' },
    { label: 'Unit Cost', key: 'unitCost' },
    { label: 'Extended Cost', key: 'extendedCost' },
    { label: 'Quote Expiration Date', key: 'expirationDate' },
  ];

  return { csvData, csvHeaders } as const;
}
